export const SUBMIT = 'SUBMIT_LOGIN';
export const EXIT = 'SUMIT_LOGOUT';
export const CHANGE_ACCOUNT = 'CHANGE_ACCOUNT';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

export const FETCH_DATA_BEGIN = 'FETCH_DATA_BEGIN';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR';